import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import Cards, { CARDS_VARIANTS } from '@components/Cards/Cards'
import TextLink, { TEXT_LINK_SIZES } from "@components/TextLink/TextLink"

import {
  DEIPageDEIUpdatesContentDIV,
  DEIPageFurtherReadingSectionContentDIV,
  DEIPageFurtherReadingSectionSECTION,
} from './DEIPageFurtherReadingSection.styles'

const DEIPageFurtherReadingSection = () => {
  const {
    postsData: { nodes: posts },
  } = useStaticQuery(graphql`query DEIPageFurtherReadingSectionQuery {
  postsData: allContentfulPost(
    filter: {
      permalink: {in: ["/blog/diversity-inclusion-2019/", "/blog/dei-spring-2019/", "/blog/dei-2021-update/", "/blog/committed-to-dei/"]}
    }
    sort: {date: DESC}
  ) {
    nodes {
      ...CardFragment
    }
  }
}`)
  return (
    <DEIPageFurtherReadingSectionSECTION>
      <div className="container">
        <div className="grid">
          <div className="column column--2-12-M column--3-11-L">
            <DEIPageFurtherReadingSectionContentDIV>
              <h3>We’re committed to this journey</h3>
              <p className="type--text-L">Diversity, Equity &amp; Inclusion work is engrained in our values at Help Scout, and we’ve been publishing our efforts since 2017. We love sharing what’s worked, what still needs work, and what we’re experimenting with as we continue to build a company where everyone can thrive.</p>
            </DEIPageFurtherReadingSectionContentDIV>
          </div>
          <div className="column">
            <Cards
              items={posts.map(post => {
                post.category = []
                return post
              })}
              variant={CARDS_VARIANTS.SMALL}
            />
          </div>
        </div>
      </div>
    </DEIPageFurtherReadingSectionSECTION>
  )
}

export default DEIPageFurtherReadingSection
